document.addEventListener("DOMContentLoaded", function () {
const tabs = document.querySelectorAll('.topContentWrapper ul li a');
const tabPanes = document.querySelectorAll('.tab-pane');
const mobileOtpButton = document.getElementById('mobile_otp_btn');
const emailOtpButton = document.getElementById('email_otp_btn');
const mobileOtpWrapper = document.getElementById('mobileOtpWrapper');
const emailOtpWrapper = document.getElementById('emailOtpWrapper');
const mobileNumberInput = document.getElementById('mobile_number');
const emailInput = document.getElementById('email_id');
const awbInput = document.getElementById('awb_input');
const awb_btnInput = document.getElementById('awb_btn');
const mobileNumberEntered = document.getElementById('mobileNumberEntered');
const emailEntered = document.getElementById('emailEntered');
const resendMobileOtpLink = document.getElementById('resendMobileOTP');
const resendEmailOtpLink = document.getElementById('resendEmailOTP');
const containerX = document.querySelector("#iframeContainer");
const mb_error = document.querySelector(".error-mb-msg");
const awd_error = document.querySelector(".error-awd-msg");
const email_error = document.querySelector(".error-email-msg");
const loaderMobile = document.querySelector('.btn.btn-success.mb');
const loaderemail = document.querySelector('.btn.btn-success.email');


awb_btnInput.addEventListener('click', function (event) {
    awb_btnInput.classList.add('track-loader');
    event.preventDefault();

    var innerSpan = awd_error.querySelector("span");
    innerSpan.textContent = awbInput.value;
    const api = `https://cpanel.mensabrands.com/TrackingShipments/public/getTracksViaAWB`;
    let storeName = 'Villain';
        fetch(api, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ 
                awb_number: awbInput.value,
                get_store_name: 'VILLAIN',
                store_name: 'Villain'
            })
        })
        .then(response =>  {
            console.log('Status Code:', response.status); // Log the status code
            if (response.status == 500) {
                awd_error.style.display = 'block';
                containerX.style.display = 'none';
            } else {
                return response.text(); // Return the parsed JSON data
            }
        })
        .then(data => {
            console.log('data');
            console.log(data);
            if (data) {
                awd_error.style.display = 'none';
                let existingIframe = containerX.querySelector('iframe');
                    if (existingIframe) {
                        containerX.removeChild(existingIframe);
                    }
                containerX.style.display = 'block';
            const iframe = document.createElement("iframe");
            iframe.src = `${data}`;
            iframe.style.cssText =
            "width: 100%; height: 500px; margin: 10px 0; border: 1px solid #d9d9d9; border-radius: 5px;";
            iframe.title = "Example Iframe";
            containerX.appendChild(iframe);
        }
        awb_btnInput.classList.remove('track-loader');

    })
    .catch(error => {
        console.error("Error:", error);
    });
    
})

// Handle tab switching
tabs.forEach(tab => {
    tab.addEventListener('click', function (event) {
        event.preventDefault();

        tabs.forEach(tab => tab.parentElement.classList.remove('active'));
        this.parentElement.classList.add('active');

        tabPanes.forEach(pane => pane.classList.remove('active'));
        document.querySelector(this.getAttribute('href')).classList.add('active');
    });
});

// Handle Send OTP button click for mobile
loaderMobile.addEventListener('click', function (e) {
    loaderMobile.classList.add('track-loader');
    if (this.textContent.trim() === 'Sent OTP') {
        // Check if mobile number is valid
        if (mobileNumberInput.value.length === 10) {
            // // Hide mobile number input
            // mobileNumberInput.classList.add('hide');
            // // Show OTP input fields
            // mobileOtpWrapper.classList.remove('hide');
            mobileNumberEntered.textContent = mobileNumberInput.value;
            // this.textContent = 'Verify OTP';
            mb_error.style.display = 'none';
        } else {
            // mobileOtpButton.classList.remove('loading');
            mb_error.style.display = 'block';
        }
    } else {
            // Check if mobile number is valid
            if (mobileNumberInput.value.length === 10) {
            // // Hide mobile number input
            // mobileNumberInput.classList.add('hide');
            // // Show OTP input fields
            // mobileOtpWrapper.classList.remove('hide');
            mobileNumberEntered.textContent = mobileNumberInput.value;
            // this.textContent = 'Verify OTP';
            var innerSpan = mb_error.querySelector("span");
            innerSpan.textContent = mobileNumberInput.value;
            mb_error.style.display = 'none';
            const api = `https://cpanel.mensabrands.com/TrackingShipments/public/getTracksViaNumber`;
        fetch(api, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ mobile_number: mobileNumberInput.value,
                store_name: 'Villain'
                })
        })
        .then(response =>  {
            console.log('Status Code:', response.status); // Log the status code
            if (response.status == 500 || response.status == 404) {
                loaderMobile.classList.remove('track-loader');
                mb_error.style.display = 'block';
                containerX.style.display = 'none';
                return null;
            } else {
                return response.json(); // Return the parsed JSON data
            }
        })
        .then(data => {
            console.log('data');
            console.log(data);
            if (data) {
                console.log('sdsdsds');
                // Get the modal
        var modal = document.getElementById("orderModal");
        var closeModal = document.querySelector('.modal-content .close');
        var tableBody = document.querySelector("#orderTable tbody");
            tableBody.innerHTML = "";

            // Populate table with response data
            let validOrders = [];
            for (let key in data) {
                if (data.hasOwnProperty(key) && data[key].ordername) {
                    validOrders.push(data[key]);
                }
            }
                    console.log(validOrders.length);
                console.log('validOrders.length');
            // Check if there is only one valid order
            if (validOrders.length === 1) {
                let singleOrder = validOrders[0];
                if (singleOrder.tracking_url) {
                    loadIframe(singleOrder.tracking_url);
                    return;
                }else{
                    var src = `https://www.shiprocket.co/tracking/${singleOrder.tracking_number}`;
                    loadIframe(src);
                    return;
                }
            }

            // Populate table and show modal for multiple orders
            for (let order of validOrders) {
                if (order.tracking_url) {
                    var orderUrl = order.tracking_url;
                } else {
                    var orderUrl = `https://www.shiprocket.co/tracking/${singleOrder.tracking_number}`;
                }
                let row = `<tr class="clickable-row" data-url="${orderUrl}">
                    <td>${order.date || ''}</td>
                    <td>${order.amount || ''}</td>
                    <td>${orderUrl ? `<a href="${orderUrl}" class="track-link" data-url="${orderUrl}" target="_blank">${order.ordername || ''}</a>` : ''}</td>
                    <td>${order.status || ''}</td>
                    
                </tr>`;
                tableBody.insertAdjacentHTML('beforeend', row);
            }

            // Display the modal
            modal.classList.add('active');
            modal.style.visibility = 'visible';
            

            const rows = document.querySelectorAll('.clickable-row');
            rows.forEach(row => {
                row.addEventListener('click', (event) => {
                    event.preventDefault(); // Prevent default behavior
                    let url = row.getAttribute('data-url'); // Use row, not this
                    console.log('url');
                    console.log(url);
                    loadIframe(url);
                    modal.classList.remove('active');
                    modal.style.visibility = 'hidden';
                    loaderMobile.classList.remove('track-loader');
                });
            });
            // Add event listener for track links
            document.querySelectorAll('.track-link').forEach(link => {
                link.onclick = function(event) {
                    event.preventDefault(); // Prevent default anchor behavior
                    let url = this.getAttribute('data-url');
                    loadIframe(url);
                    modal.classList.remove('active');
                    loaderMobile.classList.remove('track-loader');
                }
            });

            closeModal.onclick = function(event) {
                event.preventDefault(); // Prevent default anchor behavior
                modal.classList.remove('active');
                modal.style.visibility = 'hidden';
                loaderMobile.classList.remove('track-loader');
            }

            // Function to load iframe
            function loadIframe(url) {
                console.log('sadadad');
                let existingIframe = containerX.querySelector('iframe');
                if (existingIframe) {
                    containerX.removeChild(existingIframe);
                }
                
                containerX.style.display = 'block';
                const iframe = document.createElement("iframe");
                iframe.src = url;
                iframe.style.cssText = "width: 100%; height: 100vh; margin: 10px 0; border: 1px solid #d9d9d9; border-radius: 5px;";
                iframe.title = "Tracking Iframe";
                containerX.appendChild(iframe);
                loaderMobile.classList.remove('track-loader');
            }


        }

            loaderMobile.classList.remove('track-loader');
        })
        .catch(error => {
            console.error("Error:", error);
        });
        mobileOtpButton.classList.remove('loading');
        //   const data =  response.json();
        //   console.log("Data:", data);
        } else {
            loaderMobile.classList.remove('track-loader');
            mb_error.style.display = 'block';
        }
        
    }
});

// Handle Send OTP button click for email
emailOtpButton.addEventListener('click', function () {
    loaderemail.classList.add('track-loader');
    if (this.textContent.trim() === 'Send OTP') {
        // Check if email is valid
        if (emailInput.value.includes('@')) {
            // Hide email input
            emailInput.classList.add('hide');
            // Show OTP input fields
            emailOtpWrapper.classList.remove('hide');
            emailEntered.textContent = emailInput.value;
            this.textContent = 'Verify OTP';
            resendEmailOtpLink.style.display = 'block';
        } else {
            alert('Please enter a valid email address.');
        }
    } else {
        // Handle OTP verification
        console.log('OTP verified');
        var innerSpan = email_error.querySelector("span");
            innerSpan.textContent = emailInput.value;
        const api = `https://cpanel.mensabrands.com/TrackingShipments/public/getTracksViaEmail`;
        fetch(api, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email_id: emailInput.value, store_name: 'Villain' })
        })
        .then(response =>  {
            console.log('Status Code:', response.status); // Log the status code
            if (response.status == 500) {
                email_error.style.display = 'block';
                containerX.style.display = 'none';
                return;
            } else {
                return response.json(); // Return the parsed JSON data
            }
        })
        .then(data => {
            if (data) {
                // Get the modal
            var modal = document.getElementById("orderModal");
            var closeModal = document.querySelector('.modal-content .close');
            var tableBody = document.querySelector("#orderTable tbody");
                tableBody.innerHTML = "";

                // Populate table with response data
                let validOrders = [];
                for (let key in data) {
                    if (data.hasOwnProperty(key) && data[key].ordername) {
                        validOrders.push(data[key]);
                    }
                }
    
                // Check if there is only one valid order
                if (validOrders.length === 1) {
                    let singleOrder = validOrders[0];
                    if (singleOrder.tracking_url) {
                        loadIframe(singleOrder.tracking_url);
                        return;
                    }else{
                    var src = `https://www.shiprocket.co/tracking/${singleOrder.tracking_number}`;
                    loadIframe(src);
                    return;
                    }
                }
    
                // Populate table and show modal for multiple orders
                for (let order of validOrders) {
                if (order.tracking_url) {
                    var orderUrl = order.tracking_url;
                } else {
                    var orderUrl = `https://www.shiprocket.co/tracking/${singleOrder.tracking_number}`;
                }
                
                let row = `<tr class="clickable-row" data-url="${orderUrl}">
                    <td>${order.date || ''}</td>
                    <td>${order.amount || ''}</td>
                    <td>${orderUrl ? `<a href="${orderUrl}" class="track-link" data-url="${orderUrl}" target="_blank">${order.ordername || ''}</a>` : ''}</td>
                    <td>${order.status || ''}</td>
                    
                </tr>`;
                tableBody.insertAdjacentHTML('beforeend', row);
                }
    
                // Display the modal
                modal.classList.add('active');
                modal.style.visibility = 'visible';
    
                const rows = document.querySelectorAll('.clickable-row');
                rows.forEach(row => {
                    row.addEventListener('click', (event) => {
                        event.preventDefault(); // Prevent default behavior
                        let url = row.getAttribute('data-url'); // Use row, not this
                        console.log('url');
                        console.log(url);
                        loadIframe(url);
                        modal.classList.remove('active');
                        modal.style.visibility = 'hidden';
                        loaderMobile.classList.remove('track-loader');
                    });
                });
                // Add event listener for track links
                document.querySelectorAll('.track-link').forEach(link => {
                    link.onclick = function(event) {
                        event.preventDefault(); // Prevent default anchor behavior
                        let url = this.getAttribute('data-url');
                        loadIframe(url);
                        modal.classList.remove('active');
                        emailOtpButton.classList.remove('track-loader');
                    }
                });
    
                closeModal.onclick = function(event) {
                    event.preventDefault(); // Prevent default anchor behavior
                    modal.style.visibility = 'hidden';
                    modal.classList.remove('active');
                    emailOtpButton.classList.remove('track-loader');
                }
    
                // Function to load iframe
                function loadIframe(url) {
                    let existingIframe = containerX.querySelector('iframe');
                    if (existingIframe) {
                        containerX.removeChild(existingIframe);
                    }
                    containerX.style.display = 'block';
                    const iframe = document.createElement("iframe");
                    iframe.src = url;
                    iframe.style.cssText = "width: 100%; height: 100vh; margin: 10px 0; border: 1px solid #d9d9d9; border-radius: 5px;";
                    iframe.title = "Tracking Iframe";
                    containerX.appendChild(iframe);
                    emailOtpButton.classList.remove('track-loader');
                }
            }
            emailOtpButton.classList.remove('track-loader');
        })
        .catch(error => {
            console.error("Error:", error);
        });

    }
});


        
// Optionally handle resend OTP functionality
resendMobileOtpLink.addEventListener('click', function () {
    console.log('Resend OTP for mobile');
});

resendEmailOtpLink.addEventListener('click', function () {
    console.log('Resend OTP for email');
});
});
